import { EpisodeStatus } from '@/types/graphql';

export function renderEpisodeStatus(status: EpisodeStatus): string {
    switch (status) {
        case EpisodeStatus.ACTIVE:
            return 'Active';
        case EpisodeStatus.CANCELED:
            return 'Canceled';
        case EpisodeStatus.DISCHARGED:
            return 'Discharged';
        case EpisodeStatus.NON_ADMIT:
            return 'Non-Admit';
        case EpisodeStatus.ON_HOLD:
            return 'On Hold';
        case EpisodeStatus.PENDING:
            return 'Pending';
        case EpisodeStatus.RECERTIFIED:
            return 'Recertified';
    }
}
